import { Runtime } from '@/core/enums/runtime.enum'
import type { ExecutionParams, FieldExecutionParams } from '@/core/types/library.type'

type ClassData = ExecutionParams['classData'] | FieldExecutionParams['classData']

const usesBareClassNameWhenNamespaceMissing = (runtimeName: Runtime): boolean => runtimeName === Runtime.Nodejs

const isCompleteModuleFullName = (moduleFullName: string, className: string, separator: string): boolean =>
  moduleFullName === className || moduleFullName.endsWith(`${separator}${className}`)

const getRuntimeClassPath = (runtimeName: Runtime, classData: ClassData): string => {
  const moduleFullName = classData.moduleFullName?.trim()
  const separator = runtimeName === Runtime.Ruby ? '::' : '\\'

  if (moduleFullName && isCompleteModuleFullName(moduleFullName, classData.name, separator)) {
    return moduleFullName
  }

  if (!classData.namespace) return classData.name

  switch (runtimeName) {
    case Runtime.Ruby:
      return `${classData.namespace}::${classData.name}`
    case Runtime.Php:
      return `${classData.namespace}\\${classData.name}`
    default:
      return `${classData.namespace}.${classData.name}`
  }
}

export const getClassPath = (runtimeName: Runtime, classData: ClassData) => {
  if (runtimeName === Runtime.Ruby || runtimeName === Runtime.Php) {
    return getRuntimeClassPath(runtimeName, classData)
  }

  if (usesBareClassNameWhenNamespaceMissing(runtimeName)) {
    return classData.namespace ? `${classData.namespace}.${classData.name}` : classData.name
  }

  return `${classData.namespace}.${classData.name}`
}
